import React from 'react';
import { useNavigate } from 'react-router-dom';
import './UpgradePage.css';

function UpgradePage() {
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
    // In a real application, this would trigger a payment flow with Stripe, PayPal, etc.
    // For now, we'll just show a confirmation alert.
    alert('Thank you for your interest! Payment processing is coming soon.');
  };

  return (
    <div className="upgrade-page">
      <div className="upgrade-container">
        <header className="upgrade-header">
          <h1>✨ Upgrade to CourseHub Pro</h1>
          <p className="subtitle">Unlock your full potential with our most advanced AI-powered tools.</p>
        </header>

        <main className="pricing-section">
          <div className="plan-card">
            <h2>Pro Plan</h2>
            <div className="price">
              $9.99<span className="price-interval"> / month</span>
            </div>
            <ul className="features-list">
              <li>✔️ Unlimited AI Chat History</li>
              <li>✔️ Advanced Resume Analysis & Scoring</li>
              <li>✔️ AI-Powered Cover Letter Generation</li>
              <li>✔️ Mock Interview Simulations</li>
              <li>✔️ Priority Email Support</li>
            </ul>
            <button className="upgrade-button" onClick={handleUpgradeClick}>
              Upgrade Now
            </button>
          </div>
        </main>

        <footer className="upgrade-footer">
          <button onClick={() => navigate('/mentorai')} className="back-link">
            &larr; Go Back to Chat
          </button>
        </footer>
      </div>
    </div>
  );
}

export default UpgradePage;